import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { useRootPermissioning } from '@ibk/shared-permissioning';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { Loading } from '@ibk/shared-ui';
export const CreditoPJGuard = ({ children }) => {
    const { loading: permissionsLoading } = useRootPermissioning();
    const { isFeatureFlagWhiteListed, isLoading: featureFlagsLoading } = useFeatureFlag();
    if (permissionsLoading || featureFlagsLoading) {
        return _jsx(Loading, { fullScreen: true });
    }
    const hasCreditoPjAccess = !!isFeatureFlagWhiteListed(FeatureFlagUseCase.CREDITO_PJ_BANNER);
    if (!hasCreditoPjAccess) {
        return _jsx(Navigate, { to: '/home', replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
